import { render, staticRenderFns } from "./touristPortrait.vue?vue&type=template&id=01873ca5&scoped=true&"
import script from "./touristPortrait.vue?vue&type=script&lang=js&"
export * from "./touristPortrait.vue?vue&type=script&lang=js&"
import style0 from "./touristPortrait.vue?vue&type=style&index=0&id=01873ca5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01873ca5",
  null
  
)

export default component.exports